import React from "react";

const MemberHeader = ({
  selectedMember,
  handleBackToMembers,
  applicant,
  account,
}) => {
  // Determine avatar: prefer applicant.member.avatar, then selectedMember.avatar, else fallback SVG
  const avatarUrl = applicant?.member?.avatar || selectedMember?.avatar || null;

  return (
    <>
      {/* Close Button */}
      <button
        type="button"
        className="btn btn-link p-0"
        onClick={handleBackToMembers}
        style={{
          position: "absolute",
          top: "16px",
          right: "16px",
          zIndex: 10,
          color: "#6c757d",
          fontSize: "18px",
          border: "none",
          background: "none",
          cursor: "pointer",
        }}
        title="Close"
      >
        <i className="fas fa-times"></i>
      </button>

      {/* Member Header */}
      <div className="d-flex align-items-start mb-4">
        <div className="member-avatar me-3">
          {avatarUrl ? (
            <img
              src={avatarUrl}
              alt="Member Avatar"
              className="rounded-circle"
              style={{
                width: "80px",
                height: "80px",
                objectFit: "cover",
                border: "3px solid #f8f9fa",
                marginRight: "8px",
              }}
            />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              alt="Member Avatar"
              className="rounded-circle"
              style={{
                width: "80px",
                height: "80px",
                objectFit: "cover",
                border: "1px solid rgb(44 62 80 / 50%)",
                marginRight: "8px",
                fill: "#2c3e50",
              }}
            >
              <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" />
            </svg>
          )}
        </div>

        <div style={{ flex: 1 }}>
          <h4
            id="member-profile-section-title"
            className="mb-1"
            style={{ fontWeight: "600", color: "#2c3e50" }}
          >
            {applicant?.member?.name ||
              (applicant?.member ? "—" : selectedMember?.firstName) ||
              "—"}{" "}
            {applicant?.member?.surname ||
              (applicant?.member ? "—" : selectedMember?.lastName) ||
              "—"}
          </h4>
          <p className="mb-1" style={{ color: "#6c757d", fontSize: "14px" }}>
            Member ID:{" "}
            {applicant?.member?.memberNumber ||
              selectedMember?.memberNumber ||
              ""}
          </p>
          <div className="d-flex align-items-center">
            <span
              className="badge"
              style={{
                backgroundColor: "#d4edda",
                color: "#155724",
                fontSize: "12px",
                fontWeight: "500",
                padding: "4px 8px",
              }}
            >
              {account?.status === "D" ? "Inactive" : "Active"}
            </span>
          </div>
        </div>
      </div>

      {/* Action buttons */}
      <div className="d-flex gap-2 mb-4">
        <button
          type="button"
          className="flex-fill btn btn-outline-secondary"
          style={{
            width: "60px",
            height: "40px",
            borderRadius: "8px",
            border: "1px solid #dee2e6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "8px",
          }}
        >
          <i className="fas fa-comment" style={{ fontSize: "16px" }}></i>
        </button>
        <button
          type="button"
          className="flex-fill btn btn-outline-secondary"
          style={{
            width: "60px",
            height: "40px",
            borderRadius: "8px",
            border: "1px solid #dee2e6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "8px",
          }}
        >
          <i className="fas fa-envelope" style={{ fontSize: "16px" }}></i>
        </button>
        <button
          type="button"
          className="flex-fill btn btn-outline-secondary"
          style={{
            width: "60px",
            height: "40px",
            borderRadius: "8px",
            border: "1px solid #dee2e6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <i className="fas fa-calendar" style={{ fontSize: "16px" }}></i>
        </button>
      </div>
    </>
  );
};

export default MemberHeader;
